import { Component, effect, inject, Inject, signal, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';

import { CampaignWithRace } from '../../base/campaign-race';

import { InformationRaceService } from '../../services/information-race.service';
import { RaceService } from '../../services/race.service';
import { SessionService } from '../../services/session.service';
import { StarSystemService } from '../../services/star-system.service';

import { Info } from 'luxon';
import { InformationRace } from '../../interfaces/information-race';
import { Race } from '../../interfaces/race';

@Component({
    selector: 'communication',
    templateUrl: './communication.component.html',
    standalone: false
})
export class CommunicationComponent extends CampaignWithRace {
  informationRaceService = inject(InformationRaceService);
  starSystemService = inject(StarSystemService);

  fcTitle = "First Contact Policy";
  scTitle = "Communication state and secondary contact policy";
  sceTitle = "Communications Fully Established";
  scfTitle = "Communications Failed";
  pnTitle = "Treaty Negotiations";
  responsesFirstContact = ["Ignore", "Defer", "Communication"];
  responsesPostFirstContact = ["Close", "Ignore", "Withdraw", "Defer"];
  responsesPostFullComm = ["Close", "Negotiate", "Ignore", "Withdraw", "Defer"];
  starSystemHash = {};
  informationRace = {};
  informationRacesAll = signal<InformationRace[]>(undefined);
  informationRaceLocal = signal<InformationRace>(undefined);
  informationRacesNonComm: InformationRace[] = [];
  informationRacesComm: InformationRace[] = [];
  informationRacesTickedOff: InformationRace[] = [];
  allRaces: Signal<Race[]> = undefined;
  hashRaces = {};
  // hideGeneral = true;

  constructor () {
    super();
    this.informationRaceService.getAllInformationRaceForRace(this.race()._id).subscribe(
      informationRaces => {
        for (const informationRace of informationRaces) {
          this.starSystemService.getStarSystem(informationRace.aboutRace.starSystemId).subscribe(
            starSystem => this.starSystemHash[starSystem._id] = starSystem
          );
          if (informationRace.infoAboutRaceId === informationRace.infoForRaceId) {
            this.informationRaceLocal.set(informationRace);
          }
          else {
            if (informationRace.communicationState === "Impossible") {
              this.informationRacesTickedOff.push(informationRace);
            }
            else if (informationRace.communicationState === "Full") {
              this.informationRacesComm.push(informationRace);
            }
            else if (!informationRace.communicationState || informationRace.communicationState != "Full") {
              this.informationRacesNonComm.push(informationRace);
            }
          }
        }
        this.informationRacesAll.set(informationRaces);
      }
    );

    this.allRaces = toSignal(
      this.raceService.getRacesForCampaignId(this.session.campaign._id).pipe(
        tap(races => {
          this.hashRaces = races.reduce((hash, race) => (hash[race._id] = race, hash), {});
        })
      )
    );

    effect(() => {
      let ira = this.informationRacesAll();
      if (ira && ira.length >= 0) {
        let irl = this.informationRaceLocal();
        if (irl === undefined) {
          this.informationRaceService.findOrCreateInformationRace(this.session.campaign._id, this.session.race._id, this.session.race._id, this.session.race.starSystemId, this.session.campaign.turn).subscribe(
            informationRace => {
              this.informationRaceLocal.set(informationRace);
            }
          );
        }
        // this.hideGeneral = (
        //     this.informationRaceLocal.reactionOrderLowTech &&
        //     this.informationRaceLocal.reactionOrderNative &&
        //     this.informationRaceLocal.reactionOrderNonNative
        // );
      }
    });
  };

  // hide = function () {
  //     this.hideGeneral = true;
  // };

  // unhide = function () {
  //     this.hideGeneral = false;
  // };

  saveInformationRaceData (informationRace) {
    this.informationRaceService.saveInformationRace(informationRace).subscribe(
      savedInfoRace => {
        this.informationRaceLocal.set(savedInfoRace);
        this.session.setNotifyMessage("First contact communication orders have been saved.");
      }
    );
  };

  // saveGeneral = async function () {
  //     return this.saveInformationRaceData(this.informationRaceLocal).then(
  //         function (savedInfoRace) {
  //             this.informationRaceLocal = savedInfoRace;
  //             this.session.setMessageAndType("General reaction orders have been saved.", "successMessage");
  //             location.hash = '#top';
  //             return savedInfoRace;
  //         }
  //     ).catch(
  //         function (err) {}
  //     )
  // };

  saveNonComm (formToSee) {
    console.log('formToSee:', formToSee);
    let saves = [];
    for (const [index, infoRace] of (this.informationRacesNonComm).entries()) {
      let subForm = formToSee['form_' + infoRace._id];
      let saveIt = subForm.$dirty;
      if (saveIt) {
        this.informationRaceService.saveInformationRace(infoRace).subscribe(
          savedInfoRace => {
            this.informationRacesNonComm[index] = savedInfoRace;
            this.session.setNotifyMessage("Reaction orders have been saved.");
            return savedInfoRace;
          }
        );
      }
    }
    // return Promise.all(saves).then( function () {
    //     if (saved) {
    //         this.session.setMessageAndType("Non-Communication races reaction orders have been saved.", "successMessage");
    //         location.hash = '#top';
    //     }
    //     return "Done";
    // });
  };
}
